import { Text } from 'components/Text'
import theme from 'theme'
import { ForwardToLMSPageBtn } from 'components/TeacherProfile/ForwardToLMSPageBtn'
import { Box, Flex, Heading } from 'theme-ui'
import { TeacherData } from 'types'
import { useEffect, useState } from 'react'
import { mapProgressFromObj } from 'utils/dc'

export type RefresherTabProps = {
  viewMode: string
  user: TeacherData
}
export function RefresherTab({ viewMode, user }: RefresherTabProps) {
  const formatDate = (date: string) => {
    if (!date) return
    const parsedDate = Date.parse(date)
    const getMonthName = new Intl.DateTimeFormat('en-US', { month: 'long' })
      .format
    const monthName = getMonthName(parsedDate)
    const getDay = new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format
    const day = getDay(parsedDate)
    const getYear = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format
    const year = getYear(parsedDate)
    return `${monthName} ${day}, ${year}`
  }
  const progressString = !user.dcProgress
    ? ''
    : user.dcProgress.done
    ? 'Done'
    : mapProgressFromObj(user.dcProgress, 'long')

  const courseDescriptionStart = `Welcome! Here is the outline of your TM App Teacher Training refresher program showing you which Step is ready for you to begin. It will update as you progress, sharing useful information such as the due date of each Step and will always give you the action button to where you need to be.`
  const courseDescriptionMoodle = `Your course content is hosted in Moodle, a separate website that requires your private login.`
  const courseDescriptionMoodleCredentials = user?.lmsRefresherCourseData
    ?.outline?.credentials?.username
    ? `Your Moodle's username is: ${user?.lmsRefresherCourseData?.outline?.credentials?.username} and you create and manage your password.`
    : ``
  const courseDescriptionEnd = `Enjoy the course and let us know if you have any questions. Jai Guru Dev`
  const [message, setDoneMessage] = useState<string>('')

  useEffect(() => {
    if (message) {
      const id = setTimeout(() => setDoneMessage(''), 7000)
      return () => clearTimeout(id)
    }
  }, [message, setDoneMessage])
  const courseDeactivated = user.status === 'deactivated'
  return (
    <Box
      sx={{
        pt: 48,
      }}
    >
      {!courseDeactivated ? (
        <>
          <Heading variant="forms.h3">
            Refresh TM App Teacher Training Program
          </Heading>
          <Text sx={{ pt: 20, lineHeight: 2 }}>
            {courseDescriptionStart}
            <br />
            {courseDescriptionMoodle}
            <strong>{'\n' + courseDescriptionMoodleCredentials}</strong>
            {'\n' + courseDescriptionEnd}
          </Text>
          <Heading variant="forms.h2" sx={{ pt: 40 }}>
            Course outline
          </Heading>
          <Flex variant={`forms.section.${viewMode}`} sx={{}}>
            {user?.lmsRefresherCourseData?.outline?.steps?.map(
              (step, index) => (
                <>
                  <Flex
                    key={`step-${index + 1}`}
                    sx={{
                      flexBasis: '770px',
                      minHeight: 50,
                      alignItems: 'center',
                    }}
                  >
                    {index === 1 ? (
                      <>
                        <Text sx={{ flex: '0 0 240px' }}>{step?.title}</Text>
                        <Text sx={{ flex: '0 0 100px' }}>Completed</Text>
                      </>
                    ) : (
                      <>
                        <Text sx={{ flex: '0 0 240px' }}>{step?.title}</Text>
                        <Text sx={{ flex: '0 0 100px' }}>{step?.duration}</Text>
                      </>
                    )}

                    {step?.completionDate ? (
                      <Text sx={{ flex: '0 0 280px' }}>
                        Completed {formatDate(step?.completionDate)}
                      </Text>
                    ) : step?.expirationDate &&
                      step?.expirationDate > new Date().toISOString() ? (
                      <>
                        <Text
                          sx={{
                            flex: '0 0 280px',
                            color: theme.colors.warning,
                          }}
                        >
                          Due by {formatDate(step?.expirationDate)}
                        </Text>
                        <ForwardToLMSPageBtn />
                      </>
                    ) : (
                      step?.expirationDate &&
                      step?.expirationDate < new Date().toISOString() && (
                        <>
                          <Text
                            sx={{
                              flex: '0 0 280px',
                              color: theme.colors.warning,
                            }}
                          >
                            Expired {formatDate(step?.expirationDate)}
                          </Text>
                        </>
                      )
                    )}
                  </Flex>
                </>
              )
            )}
            <Heading variant="forms.h2" sx={{ pt: 40 }}>
              Digital Course Progress
            </Heading>
            <Flex
              variant={`forms.section.${viewMode}`}
              sx={{
                flexBasis: '770px',
                minHeight: 50,
                alignItems: 'center',
              }}
            >
              <Text sx={{ flex: '0 0 240px' }}>Duration: 7 hours</Text>
              <Text sx={{ flex: '1 0 100px' }}>Progress: {progressString}</Text>
            </Flex>
          </Flex>
        </>
      ) : (
        <>
          <Heading variant="forms.h3">TM App Teacher Training Program</Heading>
          <Text sx={{ pt: 20 }}>
            Your TM App Teacher Training program has been deactivated, please
            contact our support team for more information.
          </Text>
        </>
      )}
    </Box>
  )
}
